const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const baseConfig = {
  api: {
    STAGE: "local",
    BASE_URL: API_BASE_URL,
    WS_URL: process.env.REACT_APP_WS_URL ?? "localhost",
  },
  auth: {
    SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL ?? "",
    SUPABASE_PUBLIC_KEY: process.env.REACT_APP_SUPABASE_PUBLIC_KEY ?? "",
  },
};

const config = baseConfig;

if (config.api.STAGE === "production") {
  config.api.BASE_URL = process.env.PROD_API_BASE_URL ?? API_BASE_URL;
}
if (config.api.STAGE === "dev") {
  config.api.BASE_URL = process.env.DEV_API_BASE_URL ?? API_BASE_URL;
}

export default config;
